/**
 * Angular import.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { GetService } from './../../dataservices/get.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
/**
 * Constant imports.
 */
import { ACTION_TYPE, BOOLEAN, BREADCRUMB_PATHS, COMMUNITY_LIST_TYPE, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
/**
 * Model imports.
 */
import { CommunityListResponse } from '../../onboarding/interface/apiResponse.model';
import { Community, CommunityConfirmation, CommunityList, ConfirmationModalData } from '../../onboarding/interface/global.model';
/**
 * Rxjs import.
 */
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { LIST_ENTRY, LIST_EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Componet use to show past community.
 */
@Component({
  selector: 'app-community-listing-past',
  templateUrl: './community-listing-past.component.html',
  styleUrls: ['./community-listing-past.component.scss']
})
export class CommunityListingPastComponent implements OnInit, OnDestroy {
  /**
   * Breadcrumb path.
   */
  public communityListBreadcrumb = [
    { name: this.mls.languageText.community.key25, path: BREADCRUMB_PATHS.HOME },
    { name: this.mls.languageText.community.key1, path: BREADCRUMB_PATHS.COMMUNITY_LIST },
    { name: this.mls.languageText.community.key63, path: '' }
  ];
  /**
   * Community list translation.
   */
  public communityListTranslation = {
    key1: this.mls.languageText.community.key9,
    key2: this.mls.languageText.community.key5,
    key3: this.mls.languageText.community.key6,
    key4: this.mls.languageText.community.key7,
    key5: this.mls.languageText.community.key8,
    key6: this.mls.languageText.community.key55,
    key7: this.mls.languageText.community.key58,
    key8: this.mls.languageText.community.key59,
    key9: this.mls.languageText.community.key60,
    key10: this.mls.languageText.community.key72,
    key11: this.mls.languageText.community.key86,
    key12: this.mls.languageText.community.key51,
  };
  /**
   * Community card translation.
   */
  public communityCardTranslation = {
    key1: this.mls.languageText.community.key10,
    key2: this.mls.languageText.community.key3,
    key3: this.mls.languageText.community.key11,
    key4: this.mls.languageText.community.key55,
    key5: this.mls.languageText.community.key61,
    key6: this.mls.languageText.community.key87
  };
  /**
   * When there is no co,mmunity on list.
   */
  public showNoCommunity = false;
  /**
   * Communty is past key.
   */
  public isPastCommunity = true;
  /**
   * Community offset.
   */
  private offset = 1;
  /**
   * Community lsit array.
   */
  public communityList: CommunityList[] = [];
  /**
   * Scroll window key.
   */
  public scrollWindow = BOOLEAN;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * @notifier$ defines a notifier subject stream to end data streaming
   */
  private notifier$ = new Subject();
  /**
   * Community list type for past and inactive.
   */
  public filterKey = COMMUNITY_LIST_TYPE.PAST_AND_INACTIVE_COMMUNITY;
  /**
   * Community list type.
   * @confirmedCommunity contains modal and conmmunity info
   * @confirmationModal flag to show confirmation modal
   * @confirmationText contains the details to be shown in modal
   */
  public communityListType = COMMUNITY_LIST_TYPE;
  public confirmedCommunity: CommunityConfirmation;
  public confirmationModal = false;
  public confirmationText: ConfirmationModalData =
    {
      headingText: '',
      cancelButtonText: '',
      allowButtonText: '',
      bodyText: ''
    };
  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };

  public callingFrom = SCREEN_NAME.PAST_INACTIVE_COMMUNITIES_LIST;

  /**
   * number constant
   */
  public numbers = NUMBERS;

  /**
   * public screen time
   */
  private startTime: number;

  private entryData: LIST_ENTRY = {
    entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
    entity_code: 0,
    source: this.fcs.currentScreename,
    current_screen_name: '',
    start_time: 0
  };

  private exitData: LIST_EXIT = {
    entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
    entity_code: 0,
    current_screen_name: '',
    start_time: 0,
    end_time: 0
  }



  /**
   * Instance use in this component.
   */
  constructor(public mls: NewLanguageService,
              private getApiService: GetService,
              private fcs: FunCollectionService,
              private router: Router,
              private route: ActivatedRoute,
              public dss: DataStorageService,
              private analyticSdk: Analytics,) { }

  /**
   * Use to intialise getcommunity function.
   */
  ngOnInit(): void {
    this.getCommunityList(this.filterKey, 1);
    this.confirmationText = {
      bodyText: this.mls.languageText.community.key91,
      headingText: this.mls.languageText.community.key92,
      allowButtonText: this.mls.languageText.community.key93,
      cancelButtonText: this.mls.languageText.community.key94
    };
    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();
    this.startTime = new Date().getTime();
    this.entryData.start_time = this.startTime;
    this.entryData.current_screen_name = this.filterKey;
    this.analyticSdk.analyticService.LIST_ENTRY(this.entryData);
    this.fcs.currentScreename = this.filterKey;
  }

  /**
   * get the community list acc to offset and key.
   */
  getCommunityList(key: string, offset: number, concat = false): void {
    this.filterKey = key;
    this.subscriptions.add(this.getApiService.getCommunityList(key, offset.toString())
      .subscribe((res: CommunityListResponse) => {
        if (res.status === NUMBERS.ONE) {
          if (!concat) {
            this.communityList = res.data.community_list;
          } else {
            this.communityList[0].list = this.communityList[0].list.concat(res.data.community_list[0].list);
          }
          this.offset = res.data.offset;
        } else {
          this.fcs.errorHandeler(res);
        }
      }, (err) => this.fcs.errorHandeler(err)));
  }

  viewAllhandler(event): void {
    const actionOn = 'VIEWALL_' + event;
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, 0, this.filterKey, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, actionOn, null);
  }
  /**
   * set Filter
   */
  setFilter(key: string): void {
    this.communityList = [];
    if (this.filterKey?.length > 0 ) {
      this.exitData.end_time = new Date().getTime();
      this.exitData.start_time = this.startTime;
      this.exitData.current_screen_name = this.filterKey;
    }
    this.analyticSdk.analyticService.LIST_EXIT(this.exitData);
    this.startTime = new Date().getTime();
    this.entryData.start_time = this.startTime;
    this.entryData.current_screen_name = this.filterKey;
    this.analyticSdk.analyticService.LIST_ENTRY(this.entryData);
    this.entryData.source = this.fcs.currentScreename;
    this.fcs.currentScreename = this.filterKey;
    this.filterKey = key;
    this.offset = NUMBERS.ONE;
    this.getCommunityList(this.filterKey, this.offset);
    this.scrollToTop();
  }

  /**
   * Scroll to top when list gets empty/small.
   */
  scrollToTop(): void {
    this.fcs.scrollTo(0, 0);
  }

  /**
   * Get event when window scroll reach 80% of screen.
   */
  onScroll(): void {
    if (this.offset > 1) {
      this.getCommunityList(this.filterKey, this.offset, true);
    }
  }

  /**
   * Emit Edit Community Id for Community Edit
   */
  emitCommunityEdit(event): void {
    this.fcs.navigateToCommunityEditPage(event?.id);
  }
  /**
   * Community Detail
   */
  emitCommunityDetail(community): void {
    this.fcs.navigateToCommunityDetailPage(community?.id);
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.filterKey?.length > 0 ) {
      this.exitData.end_time = new Date().getTime();
      this.exitData.start_time = this.startTime;
      this.exitData.current_screen_name = this.filterKey;
    }
    this.analyticSdk.analyticService.LIST_EXIT(this.exitData);
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.notifier$.next();
    this.notifier$.complete();

    const d = new Date();
    this.sessiontime.end_time = d.getTime().toString();
  }

  /**
   * Event handler for join public community
   * @param community join public
   */
  joinPublicCommunityHandler(community: Community): void {
    if (community && community.id) {
      this.fcs.joinPublicCommunity(community.id).
        pipe(takeUntil(this.notifier$)).subscribe(
          (response) => {
            if (response.status === NUMBERS.ONE) {
              this.fcs.showSuccess(this.mls.languageText.toster.key2, this.mls.languageText.toster.key2);
              this.fcs.navigateToCommunityDetailPage(community?.id);
            } else {
              this.fcs.errorHandeler(response);
            }
          },
          error => {
            this.fcs.errorHandeler(error);
          }
        );
    }
  }

  /**
   * Confirmation withdraw request.
   */
  withdrawConfirmation(communityConfirmation: CommunityConfirmation): void {
    this.confirmedCommunity = communityConfirmation;
    this.confirmationModal = communityConfirmation.openModal;
  }

  /**
   * Allow withdraw request.
   */
  allowAction(isAllow: boolean): void {
    if (isAllow) {
      this.resetConfirmModal();
    }
  }

  /**
   * Reset confirm modal.
   */
  resetConfirmModal(): void {
    this.confirmationModal = false;
  }

  /**
   * Reload past and inactive community list
   */
  reloadPastCommunityList(): void {
    this.getCommunityList(this.filterKey, 1);
  }

  /**
   * event handler for back button
   */
  backButtonHandler(): void {
    if (this.communityList.length === NUMBERS.ONE) {
      this.setFilter(COMMUNITY_LIST_TYPE.PAST_AND_INACTIVE_COMMUNITY);
    } else {
      this.router.navigateByUrl('community/list').catch( () => {
        this.fcs.error_connection_refused('community/list');
      });
    }
  }
}
